/** Market / ZIP filter for pack views (Perihelion + deep links). */

const MARKETS_URL = "/data/markets.json";
let _markets = null;

/** Parse #/pack?market=seattle or #/pack?zips=85251,75034 */
export function parseMarketQuery() {
  const hash = location.hash || "";
  const qIdx = hash.indexOf("?");
  const params = new URLSearchParams(qIdx >= 0 ? hash.slice(qIdx + 1) : "");
  // also allow real query string before hash
  const search = new URLSearchParams(location.search || "");
  const market =
    params.get("market") ||
    search.get("market") ||
    localStorage.getItem("leadforge_market") ||
    "";
  const zipsRaw =
    params.get("zips") ||
    search.get("zips") ||
    (market === "custom" ? localStorage.getItem("leadforge_custom_zips") || "" : "") ||
    "";
  const zips = parseZipList(zipsRaw);
  return {
    market: (market || "").trim(),
    zips,
    label: params.get("label") || search.get("label") || "",
  };
}

export function parseZipList(raw) {
  const parts = String(raw || "").split(/[\s,;]+/);
  const out = [];
  const seen = new Set();
  for (const p of parts) {
    const d = p.replace(/\D/g, "").slice(0, 5);
    if (d.length === 5 && !seen.has(d)) {
      seen.add(d);
      out.push(d);
    }
  }
  return out;
}

export async function loadMarkets(force = false) {
  if (_markets && !force) return _markets;
  try {
    const res = await fetch(MARKETS_URL, { cache: "no-cache" });
    if (!res.ok) throw new Error(String(res.status));
    const j = await res.json();
    _markets = j.markets || [];
  } catch {
    _markets = [];
  }
  return _markets;
}

export async function resolveZipSet(query) {
  const q = query || parseMarketQuery();
  if (q.zips && q.zips.length) {
    return {
      zips: new Set(q.zips),
      marketId: q.market || "custom",
      marketName: q.label || (q.market === "custom" ? "Custom ZIPs" : q.market),
      source: "zips",
    };
  }
  if (!q.market || q.market === "all") {
    return { zips: null, marketId: "", marketName: "", source: "none" };
  }
  // aliases
  const alias = {
    east_valley: "phoenix_east_valley",
    tempe_mesa: "phoenix_east_valley",
    chandler_gilbert: "phoenix_east_valley",
    phoenix: "phoenix_east_valley",
  };
  const mid = alias[q.market] || q.market;
  const markets = await loadMarkets();
  const m = markets.find((x) => x.id === mid);
  if (!m) {
    return {
      zips: new Set(),
      marketId: mid,
      marketName: mid,
      source: "unknown_market",
    };
  }
  return {
    zips: new Set((m.zips || []).map((z) => String(z).slice(0, 5))),
    marketId: m.id,
    marketName: m.name || m.id,
    source: "market",
  };
}

export function filterPackByZips(pack, zipSet) {
  if (!pack || !zipSet) return pack;
  if (!(zipSet instanceof Set) || zipSet.size === 0) {
    return {
      ...pack,
      leads: [],
      lead_count: 0,
      _market_filter: { empty: true },
    };
  }
  const leads = (pack.leads || []).filter((L) => {
    const z = String(L.zip || "").slice(0, 5);
    return z && zipSet.has(z);
  });
  // also filter review_cards / leads_3d by home_id or address if present
  const ids = new Set(leads.map((L) => L.home_id).filter(Boolean));
  const addrs = new Set(leads.map((L) => String(L.address || "").toLowerCase()));
  const review_cards = (pack.review_cards || []).filter(
    (c) =>
      (c.home_id && ids.has(c.home_id)) ||
      (c.address && addrs.has(String(c.address).toLowerCase()))
  );
  const leads_3d = (pack.leads_3d || []).filter(
    (c) =>
      (c.home_id && ids.has(c.home_id)) ||
      (c.address && addrs.has(String(c.address).toLowerCase()))
  );
  return {
    ...pack,
    leads,
    lead_count: leads.length,
    review_cards,
    leads_3d,
    territory_id: pack.territory_id,
    _market_filter: { applied: true, count: leads.length },
  };
}
